/* eslint-env browser */
import Axios from 'axios'
import * as React from 'react'

const PropTypes = require('prop-types')

const Table = require('../../../client/clientjs/components/Table')

class IndividualRankingRounds extends React.Component {
  constructor(props) {
    super(props)

    const { ranking, rounds, lastRoundCountsAsTotal } = props

    let columns = [
      {
        name: 'rank',
        display: 'Rank',
        disableRotate: true,
        getCellValue: row => {
          if (lastRoundCountsAsTotal) {
            let lastRunningRound = null
            rounds.forEach(round => {
              if (round.validCircleClass !== 'not-started') {
                lastRunningRound = round
              }
            })
            if (lastRunningRound) {
              return row.scoresByRound[lastRunningRound.id].rank
            }
          }
          return row.rank
        },
        isBold: true,
        isTextCentered: true,
        isSortable: true,
      },
      {
        name: 'name',
        display: ' ',
        getCellValue: row => [
          <span key="user-name-1" className="has-margin-right-xsmall">
            {`${row.userFirstName} ${row.userLastName}`}
          </span>,
          <a key="user-link" href={`/users/${row.userId}`} target="_blank" rel="noreferrer">
            <i className="fas fa-external-link" style={{ fontSize: '0.8em' }} />
          </a>,
        ],
        getCellRawValue: row => `${row.userFirstName} ${row.userLastName}`.toLowerCase(),
        disableRotate: true,
        isSortable: true,
        getCellSubRowValue: (row, subRow) => <small className="has-text-right">{subRow.display}</small>,
        isSubRowTextCentered: true,
      },
    ].concat(
      rounds.map(round => ({
        name: `scoresByRound.${round.id}`,
        display: round.name,
        getCellValue: row => {
          const { points, score } = row.scoresByRound[round.id]
          if (round.validCircleClass === 'not-started') {
            return <span />
          }
          return (
            <span>
              {points}
              {score !== points && ` (${score})`}
            </span>
          )
        },
        getCellSubRowValue: (row, subRow) =>
          (subRow.values[round.id] || []).length > 0 && (
            <span dangerouslySetInnerHTML={{ __html: (subRow.values[round.id] || []).join('<br/>') }} />
          ),
        getCellRawValue: row => {
          const { points = 0, score = 0 } = row.scoresByRound[round.id]
          // we pad because the filter will use a string filter ! so with padding zeros we compare the right thing
          return `${`${(points || 0) * 1000}`.padStart(15, '0')}-${`${(score || 0) * 1000}`.padStart(15, '0')}`
        },
        isSortable: round.validCircleClass !== 'not-started',
        isBold: true,
        isTextCentered: true,
        isSubRowTextCentered: true,
        validCircleClass: round.validCircleClass,
      }))
    )

    let defaultSortBy = null

    if (lastRoundCountsAsTotal) {
      let lastRunningRound = null
      rounds.forEach(round => {
        if (round.validCircleClass !== 'not-started') {
          lastRunningRound = round
        }
      })
      if (lastRunningRound) {
        defaultSortBy = `scoresByRound.${lastRunningRound.id}`
      }
    }

    if (!lastRoundCountsAsTotal) {
      defaultSortBy = 'totalRoundsPoints'
      columns = columns.concat([
        {
          name: 'totalRoundsPoints',
          display: 'TOTAL',
          isBold: true,
          isTextCentered: true,
          getCellValue: row => row.totalRoundsPoints,
          isSortable: true,
        },
      ])
    }

    this.state = {
      ranking,
      columns,
      defaultSortBy,
    }

    this.onRowClick = this.onRowClick.bind(this)
  }

  onRowClick(row) {
    const { contestId } = this.props
    const { ranking } = this.state
    const rowRankingIndex = ranking.findIndex(elt => elt.userId === row.userId)

    if (rowRankingIndex === -1) {
      return
    }

    const rowRanking = ranking[rowRankingIndex]

    ranking[rowRankingIndex] = {
      ...rowRanking,
      isDisplayed: !rowRanking.isDisplayed,
      subRowsLoading: true,
    }

    this.setState({
      ranking,
    })

    if (!rowRanking || rowRanking.subRowsLoading) {
      return
    }

    Axios.get(`/api/contests/${contestId}/individualParticipations`, {
      params: {
        userId: row.userId,
      },
    }).then(response => {
      const { data = {} } = response
      const { bonuses = [], participations = [], fishesQuotaBonuses = [], differentSpeciesQuotasBonuses = [] } = data
      let subRows = bonuses.reduce((aggreg, bonus) => {
        const message = bonus.message || ''
        aggreg[message] = aggreg[message] || {
          display: message,
          values: {},
        }
        aggreg[message].values[bonus.roundId] = aggreg[message].values[bonus.roundId] || []
        aggreg[message].values[bonus.roundId].push(bonus.score)
        return aggreg
      }, {})
      subRows = fishesQuotaBonuses.reduce((aggreg, fishQuotaBonus) => {
        if (fishQuotaBonus.fishQuotaBonus > 0 === false) {
          return aggreg
        }
        const message = `${fishQuotaBonus.fishName || ''} / Bonus Quota`
        aggreg[message] = aggreg[message] || {
          display: message,
          values: {},
        }
        aggreg[message].values[fishQuotaBonus.roundId] = aggreg[message].values[fishQuotaBonus.roundId] || []
        aggreg[message].values[fishQuotaBonus.roundId].push(fishQuotaBonus.fishQuotaBonus)
        return aggreg
      }, subRows)
      subRows = differentSpeciesQuotasBonuses.reduce((aggreg, differentSpeciesQuotaBonus) => {
        if (differentSpeciesQuotaBonus.bonus > 0 === false) {
          return aggreg
        }
        const message = `Bonus ${differentSpeciesQuotaBonus.differentSpeciesCountForBonus} espèces`
        aggreg[message] = aggreg[message] || {
          display: message,
          values: {},
        }
        aggreg[message].values[differentSpeciesQuotaBonus.roundId] =
          aggreg[message].values[differentSpeciesQuotaBonus.roundId] || []
        aggreg[message].values[differentSpeciesQuotaBonus.roundId].push(differentSpeciesQuotaBonus.bonus)
        return aggreg
      }, subRows)
      subRows = participations.reduce((aggreg, participation) => {
        let message = ''
        if (participation.fishCatch) {
          const { fish, speciesCustomName } = participation.fishCatch
          if (fish && fish.names) {
            const { names } = fish
            if (names.length > 0) {
              message = names[0].value
            }
          }
          if ((message || '').length === 0) {
            message = speciesCustomName
          }
        }
        if ((message || '').length === 0) {
          message = ''
        }
        aggreg[message] = aggreg[message] || {
          display: message,
          values: {},
        }
        aggreg[message].values[participation.roundId] = aggreg[message].values[participation.roundId] || []
        aggreg[message].values[participation.roundId].push(participation.score)
        return aggreg
      }, subRows)
      subRows = Object.values(subRows).sort((a, b) => {
        const sumA = Object.values(a.values)
          .flat()
          .reduce((res, elt) => res + elt, 0)
        const sumB = Object.values(b.values)
          .flat()
          .reduce((res, elt) => res + elt, 0)
        return sumB - sumA
      })

      this.setState(prevState => {
        const newRanking = prevState.ranking
        newRanking[rowRankingIndex] = {
          ...newRanking[rowRankingIndex],
          subRows,
          subRowsLoading: false,
        }
        return {
          ranking: newRanking,
        }
      })
    })
  }

  render() {
    const { scoreLessIsMore } = this.props

    const { ranking, columns, defaultSortBy } = this.state

    return (
      <Table
        rows={ranking}
        columns={columns}
        getRowKey={row => row.userId}
        onRowClick={this.onRowClick}
        getSubRows={row => (row.isDisplayed ? row.subRows || [] : [])}
        getSubRowKey={(row, subRow) => `${row.userId}-subrow-${subRow.display}`}
        tableClass="is-size-7 is-size-8-mobile is-self-centered"
        defaultSortBy={defaultSortBy}
        defaultSortASC={scoreLessIsMore}
      />
    )
  }
}

IndividualRankingRounds.propTypes = {
  contestId: PropTypes.string.isRequired,
  ranking: PropTypes.array,
  rounds: PropTypes.array,
  scoreLessIsMore: PropTypes.bool,
  lastRoundCountsAsTotal: PropTypes.bool,
}

IndividualRankingRounds.defaultProps = {
  ranking: [],
  rounds: [],
  scoreLessIsMore: false,
  lastRoundCountsAsTotal: false,
}

module.exports = IndividualRankingRounds
